module.exports = __webpack_public_path__ + "img/icon-close-dark.be0121a5.svg";